<template>
  <div class="container-listagem-socios">
    <p class="titulo-campo-preenchivel"><strong>Dados do(s) sócio(s)</strong></p>
    <br/>
    <TrfButton
      nome="Adicionar sócio"
      class="mb-3"
      :temIcon="true"
      classIcon="mdi-plus-thick"
      classCor="is-primary"
      width="115px"
      height="22px"
      fontSize="12px"
      type="button"
      :disabled="isVisualizacao"
      @click="doIniciarFormSocio"
      v-e2e="'addSocio-listagemSocio'"
      :class="{'is-preview': preview}"
    />
      <TrfSimpleTable 
        :configuracaoDeColunas="configuracaoDeColunas"
        :dados="listagemDados"
        :isCliente=false
        mensagemSemDados="Não há sócios adicionados"
        :isSelectable="false"
        :hasSlotLine="false"
        :isToggleble="false"
        :isMultipleSelection="false"
        >
          <template #tipo="{item}">
            <span v-if="item.isAdministrador">Administrador</span>
            <span v-if="item.isAdministrador && item.isResponsavelCnpj">, </span>
            <span v-if="item.isResponsavelCnpj">
              Responsável CNPJ
            </span>
          </template>
        
          <template v-if="showMaisAcoes" #acoes="{item, index}">
            <div v-if="!isVisualizacao" class="dropdown is-pulled-right is-right" :class="{'is-active': maisAcoesAberta == index}">
              <div class="dropdown-trigger" @click="() => clickMaisAcoes(index)">
                <span class="icon is-small">
                    <i class="mdi mdi-dots-horizontal mdi-24px" aria-hidden="true"></i>
                </span>
              </div>
              <div class="dropdown-menu" role="menu">
                <div class="dropdown-content is-pulled-right is-active">
                  <a
                    title="Excluir sócio"
                    class="dropdown-item is-small"
                    @click="() => doExcluirFormSocio(index)"
                  >
                    <i class="mdi mdi-delete mdi-14px" aria-hidden="true"></i>Excluir
                  </a>

                  <a
                    title="Editar sócio"
                    class="dropdown-item is-small"
                    @click="() => doEditarFormSocio(item)"
                  >
                    <i class="mdi mdi-pencil mdi-14px" aria-hidden="true"></i>Editar
                  </a>
                </div>
              </div>
            </div>

            <button
              v-if="isVisualizacao"
              data-label="btn-visualizar-socio"
              class="button is-pulled-right"
              title="Visualizar sócio"
              type="button"
              @click.prevent="doVisualizarFormSocio(item)"
            >
              <span class="icon">
                <i class="mdi mdi-eye mdi-18px" aria-hidden="true"></i>
              </span>
            </button>
          </template>
    </TrfSimpleTable>
  </div>
</template>

<script>
  import { defineAsyncComponent } from 'vue';
  
  export default {
    name: 'TrfListagemDeSociosCadastro',
    emits: ['elegalize-iniciar-formulario-socio', 'elegalize-editar-formulario-socio' ,'elegalize-visualizar-formulario-socio', 'elegalize-excluir-formulario-socio'],
    components: {
      TrfButton: defineAsyncComponent(() => import('../../../../components/Button/index.vue')),
      TrfSimpleTable: defineAsyncComponent(() => import('../../../../components/SimpleTable/index.vue')),
    },
    props: {
      listagemDeSocios: {
          type: Array,
          default: new Array(),
          required: false
      },
      preview: {
        type: Boolean,
        default: false,
        required: false
      },
      isVisualizacao: {
        type: Boolean,
        default: false,
        required: false
      },
      showMaisAcoes: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        maisAcoesAberta: null,
        formData: [],
        configuracaoDeColunas: [
          {
            titulo: "Nome do sócio",
            nome: "nome",
            referencia: ['nome'],
            divisor: ""
          },
          {
            titulo: "CPF",
            nome: "cpf",
            referencia: ['cpf'],
            divisor: ``
          },
          {
            titulo: "Tipo",
            nome: 'tipo',
            referencia: ['tipo'],
            divisor: "",
            slot: true
          },
          {
            titulo: "",
            nome: 'acoes',
            referencia: ['acoes'],
            divisor: "",
            slot: true,
            customStyle: "width: 100px;",
          }
        ],
      };
    },
    computed: {
      listagemDados() {
          //formata listagem de socios para tabela
          return this.listagemDeSocios
      }
    },
    methods: {
      async doIniciarFormSocio() {
        if (this.preview) return;
        
        this.$el.dispatchEvent(
          new CustomEvent('elegalize-iniciar-formulario-socio', {
            detail: {
              titulo: 'Cadastrar sócio',
              form: 'socio',
              acaoConfirma: null,
              acaoCancela: null,
              labelConfirma: 'Cadastrar',
              dadosEdicao: null,
            },
            composed: true,
            bubbles: true
          })
        );
        await this.$nextTick();
        this.scrollToTop();
      },
      async doEditarFormSocio(dados) {
        if (this.preview) return;
        
        this.fecharMaisAcoes();
        this.$el.dispatchEvent(
          new CustomEvent('elegalize-editar-formulario-socio', {
            detail: {
              titulo: 'Editar sócio',
              form: 'socio',
              acaoConfirma: null,
              acaoCancela: null,
              dadosEdicao: dados,
              labelConfirma: 'Editar sócio'
            },
            composed: true,
          })
        );
      },
      doExcluirFormSocio(index) {
        if (this.preview) return;
        
        this.fecharMaisAcoes();
        this.$el.dispatchEvent(
          new CustomEvent('elegalize-excluir-formulario-socio', {
            detail: {
              index
            },
            composed: true,
          })
        );
      },
      async doVisualizarFormSocio(dados) {
        if (this.preview && !this.isVisualizacao) return;
        
        this.$el.dispatchEvent(
          new CustomEvent('elegalize-visualizar-formulario-socio', {
            detail: {
              titulo: 'Visualizar sócio',
              form: 'socio',
              acaoConfirma: null,
              acaoCancela: null,
              dadosVisualizacao: dados,
            },
            composed: true,
          })
        );
      },
      scrollToTop() {
        const modalCadastroProcesso = document.querySelector('#modal-cadastro-processo .modal-card-body.scroll-personalizado')
        if(!!modalCadastroProcesso) {
          modalCadastroProcesso.scrollTo(0, 0);
        }
      },
      clickMaisAcoes(index) {
        this.maisAcoesAberta = this.maisAcoesAberta === index ? null : index;
      },
      fecharMaisAcoes() {
        this.maisAcoesAberta = null;
      }
    },
    mounted() {
    }
  };
</script>

<style lang="scss" scoped>
  .multiselect-econtador {
    margin: 0;
  }
  
  .is-preview {
    pointer-events: none;
    cursor: default!important;
    * {
      pointer-events: none;
      cursor: default!important;
    }
  }
</style>